import { Box, Flex, Stack, Text } from "@chakra-ui/react";
import { Breadcrumb } from "../Breadcrumb";
import { CenteredContent } from "../CenteredContent";

/**
 * @typedef {Object} Props
 * @property {string} [title]
 * @property {import("../Breadcrumb").BreadcrumbItem[]} [breadcrumbItems]
 * @property {import("react").ReactNode} [leftAddon]
 * @property {import("react").ReactNode} [bottomAddon]
 * @property {import("react").ReactNode} [children]
 */
/**
 * @param {Props} props
 */
export function PageLayout({
  title,
  breadcrumbItems,
  leftAddon,
  bottomAddon,
  children,
}) {
  const hasLeftAddon = leftAddon !== undefined;

  return (
    <Box>
      <CenteredContent maxWidth={hasLeftAddon ? "1420px" : "none"}>
        <Flex
          flexDirection={{ base: "column", lg: "row" }}
          w="full"
          alignItems="flex-start">
          {leftAddon && (
            <Box
              flexShrink={0}
              display={{ base: "none", lg: "block" }}
              position="sticky"
              top="136px"
              w="387px">
              {leftAddon}
            </Box>
          )}

          <Box
            flexGrow={1}
            w="full"
            mt="32px"
            mr={{
              base: "0",
              lg: hasLeftAddon ? "calc(120px - 16px)" : undefined,
            }}>
            {((breadcrumbItems !== undefined && breadcrumbItems.length > 0) ||
              title !== undefined) && (
              <Box px="16px">
                <CenteredContent>
                  <Stack>
                    {breadcrumbItems !== undefined &&
                      breadcrumbItems.length > 0 && (
                        <Breadcrumb items={breadcrumbItems} />
                      )}

                    {title !== undefined && <Text variant="h1">{title}</Text>}
                  </Stack>
                </CenteredContent>
              </Box>
            )}

            {leftAddon && (
              <Box display={{ base: "block", lg: "none" }} mt="16px">
                {leftAddon}
              </Box>
            )}

            <Box pt="24px" pb="64px">
              {children}
            </Box>
          </Box>
        </Flex>
      </CenteredContent>

      {bottomAddon}
    </Box>
  );
}
